<script setup lang="ts">
import { selectionActions } from "@/action/selectionActions";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";

import OrganizeMenu from "./OrganizeMenu.vue";
</script>

<template>
  <ActionMenuDropdown :action="selectionActions.organizeStickies">
    <OrganizeMenu />
  </ActionMenuDropdown>
</template>
